// extracted by mini-css-extract-plugin
module.exports = {"chart":"index_chart_3-kTB"};